import { apiClientWithRefreshToken } from "@/api/apiClient";
import { UpdatePasswordSchema } from "@/v2/schema/members";
import { User } from "@/v2/types";

export default async function UpdatePassword({
    id,
    data,
}: {
    id: string;
    data: UpdatePasswordSchema;
}): Promise<User> {
    const res = await apiClientWithRefreshToken({
        url: `/update-password/${id}`,
        method: "PUT",
        data: { id: id, password: data.password },
    });

    return res.data;
}
